module.exports = __webpack_public_path__ + "static/save_as_template_2-98d8f1c63517a9bc754f28f1f44f81b8.png";